import { useEffect } from 'react';
import { _GetAccessToken } from '@netfront/gelada-react-shared';
import { useRouter } from 'next/router';

export function useProtectedRoute() {
  const { push, asPath } = useRouter();

  useEffect(() => {
    Boolean(_GetAccessToken()) || push({ pathname: '/login', query: { prepath: asPath } });
  });
}
